<template>
  <div class="issueSearch">
    <div class="headerBox">
      <div class="header">
        <van-field
          class="box"
          v-model="keyword"
          placeholder="请输入搜索内容"
        >
          <template #left-icon>
            <img class="icon" :src="require('@/assets/images/icon_search_01.png')" />
          </template>
        </van-field>
        <div class="btn" @click="$router.back()">取消</div>
      </div>
    </div>
    <van-tabs
      v-model="active"
      sticky
      :offset-top="`${108*$utils.ratio}px`"
      animated
      swipeable
      @change="tabChange"
    >
      <van-tab title="圈子">
        <van-pullRefresh v-model="page.refreshing" @refresh="init">
          <Empty v-if="page.totalCount === 0" />
          <van-List
            v-else
            :immediate-check="active === 0"
            :key="page.totalCount"
            v-model="page.loading"
            :finished="page.finished"
            @load="onLoad"
          >
            <CircleItem
              v-for="(item, index) in page.list"
              :key="index"
              :detail="item"
              @click="jumpTo('CircleDetail', item.id)"
              @handleButton="handleFollow('circleDetail', item)"
            />
            <template #finished>
              <van-divider class="list-bottom-tip">滑到底啦</van-divider>
            </template>
          </van-List>
        </van-pullRefresh>
      </van-tab>
      <van-tab title="提问">
        <van-pullRefresh   v-model="page.refreshing" @refresh="init">
          <Empty v-if="page.totalCount === 0" />
          <van-List
            v-else
            :immediate-check="active === 1"
            :key="page.totalCount"
            v-model="page.loading"
            :finished="page.finished"
            @load="onLoad"
          >
            <ul class="list list-1">
              <li
                class="list-item"
                v-for="item in page.list"
                :key="item.id"
                @click="jumpTo('IssueDetail',item.id)"
              >
                <i class="icon icon-wen"></i>
                <div class="name text-ellipsis">{{item.name}}</div>
              </li>
            </ul>
            <template #finished>
              <van-divider class="list-bottom-tip">滑到底啦</van-divider>
            </template>
          </van-List>
        </van-pullRefresh>
      </van-tab>
      <van-tab v-if="false" title="动态">
        <Empty v-if="!page3.list.length" />
        <van-pullRefresh v-else v-model="page3.refreshing" @refresh="init">
          <van-List
            v-model="page3.loading"
            :finished="page3.finished"
            @load="onLoad(3)"
          >
            <UpdateItem v-for="(item,index) in page3.list" :key="index" :detail="item" @click="jumpTo('UpdateDetail',item)" />
            <template #finished>
              <van-divider style="width:50%;margin:20px auto;">滑到底啦</van-divider>
            </template>
          </van-List>
        </van-pullRefresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Field } from 'vant';
import { Empty } from '@/components';
import CircleItem from '@/views/tabBar/components/CircleItem';
import UpdateItem from '@/views/tabBar/components/UpdateItem';
export default {
  name: 'IssueSearch',
  components: { 'van-field': Field, Empty, CircleItem, UpdateItem },
  data () {
    return {
      keyword: '',
      active: 0,
      page: {
        list: [],
        pageNo: 1,
        pageSize: 20,
        totalCount: '',
        loading: false,
        finished: false,
        refreshing: false
      },
      timer: null
    };
  },
  watch: {
    $route: {
      handler ({ name, query: { active } }) {
        if (name === 'IssueSearch') {
          this.active = active * 1 || 0;
          this.keyword = '';
          this.init();
        }
      },
      immediate: true
    },
    keyword () {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.init();
      }, 300);
    }
  },
  methods: {
    init () {
      this.page = {
        list: [],
        pageNo: 1,
        pageSize: 20,
        totalCount: '',
        loading: false,
        finished: false,
        refreshing: false
      };
    },
    onLoad () {
      const { page, active, keyword } = this;
      let apiurl = '';
      switch (active) {
        case 0:
          apiurl = 'community/circle/all/list';
          break;
        case 1:
          apiurl = 'community/circle/ask/search';
          break;
      }
      this.$http.get(apiurl, {
        params: {
          pageNo: page.pageNo,
          pageSize: page.pageSize,
          keyword
        }
      }).then((res) => {
        let data = res.data || {};
        if (active === 0) {
          data = data.page || {};
        }
        page.list.push(...(data.result || []));
        page.pageNo++;
        page.totalCount = data.totalCount || 0;
        page.loading = false;
        page.finished = !data.isHasNext;
        page.refreshing = false;
      });
    },
    jumpTo (name, id) {
      this.$router.push({
        name,
        query: {
          id
        }
      });
    },
    handleFollow (name, item) {
      if (this.$goToLogin()) {
        let apiUrl = 'community/circle/follow';
        let message = '关注成功';
        if (item.follow) {
          apiUrl = 'community/circle/unFollow';
          message = '已取消关注';
        }
        this.$http.post(apiUrl, {
          id: item.id
        }, {
          showLoading: true,
          loadingText: ' '
        }).then((res) => {
          item.follow = !item.follow;
          item.followers += item.follow ? 1 : -1;
          this.$utils.successToast(message);
        });
      }

    },
    tabChange (e) {
      this.onReplace({
        active: e
      });
    },
    onReplace (params = {}) {
      const { $router } = this;
      $router.replace({
        query: { active: params.active }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.issueSearch {
  /deep/
  .van-tabs{
    .van-tabs__line{
      background-image: url('~@/assets/images/icon_tab_green.png');
    }
    .van-tab--active {
      color: @primaryGreen;
    }
  }
  .headerBox {
    width: 100%;
    height: 108px;
    position: relative;
    .header {
      position: fixed;
      top: 0;
      right: 0;
      width: 100%;
      height: 108px;
      padding: 20px 28px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      z-index: 10;
      .box {
        width: 610px;
        height: 68px;
        line-height: 36px;
        background: #F9FAFC;
        border-radius: 36px;
        padding: 16px 28px;
        display: flex;
        align-items: center;
        /deep/ .van-field__left-icon {
          display: flex;
          align-items: center;
        }
        .icon {
          width: 36px;
          height: 36px;
          margin-right: 12px;
        }
      }
      .btn {
        width: 56px;
        height: 40px;
        font-size: 28px;
        font-weight: 400;
        color: #333444;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .list{
    padding-left: 28px;
    padding-right: 28px;
    &.list-1{
      .list-item {
        padding-top: 40px;
        padding-bottom: 40px;
        border-bottom: 2px solid #F0F0F0;
        display: flex;
        align-items: center;
        .icon {
          width: 34px;
          height: 34px;
          margin-right: 12px;
          background-image: url("~@/assets/images/issue/icon_wen_02.png");
        }
        .name {
          flex: 1;
          width: 0;
          font-size: 32px;
          color: #333444;
        }
      }
    }
  }
}
</style>